import { render } from "./summernote.vue?vue&type=template&id=3cdeb3a2"
import script from "./summernote.vue?vue&type=script&lang=js"
export * from "./summernote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__